import { AdminAppState, EventEntry } from '../../state';
import { getEvents } from './get-events';

export const getEventEntry = (eventKey: string) => (
  state: AdminAppState,
): EventEntry => {
  const events = getEvents(state);
  const entry = events[eventKey];
  if (entry) {
    return entry;
  } else {
    throw new Error(`Missing event: ${eventKey}`);
  }
};
